import "./App.css";
import Documents from "./components";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./components/screens/AppThemeCustom";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Documents />
    </ThemeProvider>
  );
}

export default App;
